import React from 'react';

import './Info.css';
import { Statement } from './Statement/Statement';


export const Info = () => (
  <div>
    <p>
      Wilt u deze verzekering afsluiten? Ga naar uw financieel adviseur of
      <a href="https://www.taf.nl/service-en-contact/vind-een-adviseur">vind een adviseur</a>
      bij u in de buurt
    </p>
    <Statement/>
  </div>
);
